<template>
  <div class="TopicFilterComponent colorBlock">
    <div class="container">
      <div class="row">
        <!-- Left Sidebar: Filters -->
        <div class="col-xs-12 col-md-4 col-lg-3 topicSidebar">
          <h2 class="mobileOnly">{{ heading }}</h2>

          <button
            id="allFiltersToggle"
            @click="toggleAllFilters"
            :class="mobileFilters"
          >
            All Filters <i class="fa fa-chevron-down" />
          </button>
          <!-- Filter container -->
          <div id="topicFilterContainer" :class="mobileFilters">
            <AppliedFilters :filters="appliedFilters" @remove="removeFilter" />

            <h2>All Filters</h2>

            <!-- Keyword search component -->
            <KeywordSearch
              :keywords="checkedFilters.keywords"
              @add="addKeyword"
            
            />
            <!-- Checkbox filters for Amenities -->
            <Checkboxes
              :title="'Amenities'"
              :options="filters.amenities"
              v-model="checkedFilters.amenities"
            />
            <!-- -->
          </div>
        </div>
        <!-- Right content: Cards -->
        <div class="col-xs-12 col-md-8 col-lg-9 topics">
          <CardSet
            :cards="filteredCards"
            :heading="heading"
            :page="page"
            @clear="clearAllFilters"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardSet from "@/components/CardSet.vue";
import KeywordSearch from "@/components/KeywordSearch.vue";
import Checkboxes from "@/components/Checkboxes.vue";
import AppliedFilters from "@/components/AppliedFilters.vue";

export default {
  name: "FilterSection",
  props: {
    actions: Array,      // Array of all park objects
    filters: Object,     // Available filters (like amenities)
    page: Number,        // Page number for CardSet component
    prefilter: {         // Optional pre-selected filter
      type: String,
      default: "",
    },
  },
  data() {
    return {
      checkedFilters: {
        amenities: [],   // Selected amenities
        keywords: [],    // Selected keywords
      },
      mobileFilters: false,
    };
  },
  created() {
    this.applyPrefilter();
  },
  watch: {
    prefilter() {
      this.applyPrefilter();
    },
  },
  computed: {
    // Heading showing filtered count, e.g., "3/20 Parks"
    heading() {
      let cards = this.filteredCards.length,
        allCards = this.actions.length,
        heading = cards != allCards ? `${cards}/${allCards}` : allCards;

      heading += cards == 1 ? " Park" : " Parks";

      return heading;
    },
    // Combine all applied filters for display (amenities + keywords)
    appliedFilters() {
      return [
        ...this.checkedFilters.amenities,
        ...this.checkedFilters.keywords,
      ];
    },
    // Build a search index for each park for keyword filtering
    searchIndex() {
      return this.actions.map((action) => {
        let index = "";

        // Loop through attributes like Art_in_Park, Baseball_Softball, PMA, NAME, etc.
        for (const property in action.attributes) {
          // console.log("my prop" + property);
          // property e.g. Art_in_Park, Baseball_Softball, PMA, NAME, etc.
          if(action.attributes[property] === "Yes"){
            index += property;
          }
          // index is use for the keyword search
          index += ` ${action.attributes[property]} ` + " " + action.desc;
          // console.log("Property nflores " + index + " --END ")
        }
      // console.log(action.attributes.PMA)
      // console.log(index.toLowerCase())
    
        return {
     
          id: action.attributes.PMA,
          index: index.toLowerCase(),
        };
      });
    },
    // Apply filters and return only the cards that match
    filteredCards() {
      let cards = this.actions 
      let amenities = this.checkedFilters.amenities
      
      // --- Filter by amenities --
      if (amenities.length > 0) {
        cards = cards.filter((card) => {
          if (!card.attributes) return false;

          // Check that **every selected amenity** exists in the park
          return amenities.every((amenity) => {
            return Object.entries(card.attributes).some(([key, value]) => {
              if (value !== "Yes") return false;
              // Convert key like "Baseball_Softball" → "Baseball Softball"
              const formattedKey = key.replaceAll("_", " ").replace(/([a-z])([A-Z])/g, '$1 $2');
              return formattedKey === amenity;
            });
          });
        });
      }


      // --- Filter by keywords ---
      let keywords = this.checkedFilters.keywords;

      if (keywords.length > 0) {
        for (const keyword of keywords) {
          console.log('filtering on keyword: ', keyword)
          cards = cards.filter((x) => {
            // Look up the prebuilt search index
            let searchIndex = this.searchIndex.find((item) => item.id == x.attributes.PMA);
            // Keep card if keyword is found in index
            return searchIndex?.index?.indexOf(keyword.toLowerCase()) > -1;
          });
        }
      }

      return cards; // Return filtered results
    },
  },
  components: {
    CardSet,
    KeywordSearch,
    Checkboxes,
    AppliedFilters,
  },
  methods: {
    // Toggle mobile filter panel open/close
    toggleAllFilters() {
      this.mobileFilters = this.mobileFilters == "active" ? "" : "active";
    },
    // Remove a filter (from amenities or keywords)
    removeFilter(filter) {
      for (const [key, filterSet] of Object.entries(this.checkedFilters)) {
        // console.log(`${key}: ${filterSet}`);

        if (filterSet.includes(filter)) {
          this.checkedFilters[key] = filterSet.filter((x) => x != filter);
        }
      }
    },
    // Clear all filters
    clearAllFilters() {
      console.log("clearing all filters");

      console.log(this.filterReset);

      this.checkedFilters = {
        amenities: [],
        keywords: [],
      };
    },
    // Add a keyword to filter list
    addKeyword(keyword) {
      this.checkedFilters.keywords.push(keyword);
    },
    // Apply prefilter prop (select filter automatically)    
    applyPrefilter() {
      if (this.prefilter.length > 0) {
        const removeSpecialChars = (string) => {
          return string
            .replace(/"|\/|_|-|~|,|\.|#/g, " ")
            .toLowerCase()
            .trim();
        };
        // console.log(removeSpecialChars('criminal-justice'))
        // console.log(removeSpecialChars('Criminal Justice'))
        // console.log('Prefilter Prop: ', this.prefilter)

        // Loop through all the filter collections
        for (const [key, filterSet] of Object.entries(this.filters)) {
          // Reset checked filters
          this.checkedFilters[key] = [];

          // Loop through all filters in a collection
          for (const filter of filterSet) {
            // Check to see if the prefilter exists in the filter collection
            if (
              removeSpecialChars(filter) == removeSpecialChars(this.prefilter)
            ) {
              // Add the filter to the checked list
              this.checkedFilters[key].push(filter);
            }
          }
        }
      }
    },
  },
};

</script>

<style lang="scss">
  #mainColMain {

    .TopicFilterComponent.colorBlock {
      border-bottom: 1px solid #ccc;

      .topics {
        .allCards {
          margin: 0 0 0 3px;

          h2 {
            border-bottom: none;
            color: #666;
          }
        }
      }

      @media (max-width: 991px) {
        padding-top: 0px !important;

        #topicFilterContainer {
          background: #f1f1f1;
          border: 0;
          padding: 5px 20px 20px;
          display: none;

          &.active {
            display: block;
          }
        }
      }
    }

  .mobileOnly {
    @media (min-width: 992px) {
      display: none;
    }
  }

  #allFiltersToggle {
    display: none;

    @media (max-width: 991px) {
      display: block;
      width: calc(100% + 12px);
      margin: 10px -5px 0;
      background: #fff;
      border: 1px solid #003da5;
      color: #003da5;
      height: 50px;
      font-weight: bold;

      i,
      svg {
        margin-left: 5px;
      }

      &.active {
        i,
        svg {
          transform: rotate(180deg);
        }
      }
    }
  }

  #topicFilterContainer {
    padding-right: 35px;

    @media (max-width: 991px) {
      width: calc(100% + 12px);
      margin: 0 -5px;
    }

    h2 {
      font-size: 24px;
      border-bottom: none;
    }
    h3 {
      font-size: 16px;
      font-family: "Open Sans", sans-serif;
    }
    .checkbox {
      height: 34px;
      margin-bottom: 10px;
    }

    input[type="checkbox"] + label {
      font-weight: bold;
      font-size: 14px;
      line-height: 16px;
      display: flex;
      align-items: center;

      &:before {
        min-width: 24px;
        margin-left: -40px;
        margin-bottom: 0px;
      }
    }

    button.showAllFilters {
      background: transparent;
      border: 0;
      font-weight: bold;
      color: #003da5;
    }
  }

}

</style>